import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74ca8b4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-main-menu --fixed" }
const _hoisted_2 = { class: "oxd-main-menu-search" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "oxd-main-menu-divider" }, null, -1))
const _hoisted_4 = { class: "oxd-main-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon_button = _resolveComponent("oxd-icon-button")!
  const _component_oxd_main_menu_item = _resolveComponent("oxd-main-menu-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_oxd_icon_button, {
          name: _ctx.toggle ? 'chevron-right' : 'chevron-left',
          class: "oxd-main-menu-button",
          role: "none",
          onClick: _ctx.onClickCollapse
        }, null, 8, ["name", "onClick"])
      ]),
      _hoisted_3
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMenuItems, (menuItem, index) => {
        return (_openBlock(), _createBlock(_component_oxd_main_menu_item, {
          key: `oxd-main-menu-${index}`,
          url: menuItem.url,
          active: menuItem.active,
          collapsed: _ctx.toggle,
          name: menuItem.name,
          icon: menuItem.icon
        }, null, 8, ["url", "active", "collapsed", "name", "icon"]))
      }), 128))
    ])
  ], 64))
}